import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
import { PondLogsIcon } from '@eruvaka/web-pondlogs-auth';
import { colorTokens } from '@eruvaka/web-pondlogs-base';
const btnPrimary = {
    padding: '8px 20px',
    borderRadius: 9,
    background: colorTokens.primary,
    color: colorTokens.white,
    fontSize: 12,
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontFamily: "'Nunito', sans-serif",
    boxShadow: `0 3px 12px ${colorTokens.primary}44`,
};
export const LandingPage = ({ onStartSetup }) => {
    const { t } = useTranslation('main');
    return (_jsx("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            height: '100%',
            padding: '32px',
            textAlign: 'center',
            background: colorTokens.lightGrey,
        }, children: _jsxs("div", { style: { maxWidth: 520 }, children: [_jsx("div", { style: {
                        width: 72,
                        height: 72,
                        borderRadius: '50%',
                        background: `linear-gradient(135deg,${colorTokens.secondary},${colorTokens.secondaryDark})`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 20px',
                        boxShadow: `0 8px 28px ${colorTokens.secondary}44`,
                    }, children: _jsx(PondLogsIcon, { size: 38, color: "white" }) }), _jsx("div", { style: {
                        width: 32,
                        height: 3,
                        borderRadius: 2,
                        background: colorTokens.magenta,
                        margin: '0 auto 16px',
                    } }), _jsx("h1", { style: {
                        fontSize: 26,
                        fontWeight: 800,
                        color: colorTokens.primary,
                        marginBottom: 8,
                        lineHeight: 1.2,
                        fontFamily: "'Nunito', sans-serif",
                    }, children: t('landing.welcome') }), _jsx("p", { style: {
                        fontSize: 13,
                        color: colorTokens.darkGrey,
                        lineHeight: 1.8,
                        marginBottom: 32,
                        fontFamily: "'Nunito', sans-serif",
                    }, children: t('landing.setupDescription') }), _jsxs("div", { style: {
                        background: colorTokens.white,
                        border: `1px solid ${colorTokens.borderLight}`,
                        borderRadius: 14,
                        padding: '18px 24px',
                        marginBottom: 28,
                        textAlign: 'left',
                        boxShadow: '0 2px 10px rgba(0,60,113,0.06)',
                    }, children: [_jsx("div", { style: {
                                fontSize: 10,
                                fontWeight: 800,
                                color: colorTokens.darkGrey,
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                                marginBottom: 14,
                                fontFamily: "'Nunito', sans-serif",
                            }, children: t('landing.setup.whatYouWillDo') }), [
                            {
                                num: 1,
                                label: t('landing.setup.step1Label'),
                                desc: t('landing.setup.step1Description'),
                                color: colorTokens.secondary,
                                req: true,
                            },
                            {
                                num: 2,
                                label: t('landing.setup.step2Label'),
                                desc: t('landing.setup.step2Description'),
                                color: colorTokens.primary,
                                req: false,
                            },
                            {
                                num: 3,
                                label: t('landing.setup.step3Label'),
                                desc: t('landing.setup.step3Description'),
                                color: colorTokens.magenta,
                                req: false,
                            },
                        ].map((item, i) => (_jsxs("div", { style: {
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 12,
                                marginBottom: i < 2 ? 14 : 0,
                                paddingBottom: i < 2 ? 14 : 0,
                                borderBottom: i < 2 ? `1px solid ${colorTokens.borderLight}` : 'none',
                            }, children: [_jsx("div", { style: {
                                        width: 26,
                                        height: 26,
                                        borderRadius: '50%',
                                        background: `${item.color}18`,
                                        border: `2px solid ${item.color}35`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        marginTop: 1,
                                    }, children: _jsx("span", { style: {
                                            fontSize: 11,
                                            fontWeight: 800,
                                            color: item.color,
                                            fontFamily: "'Nunito', sans-serif",
                                        }, children: item.num }) }), _jsxs("div", { style: { flex: 1 }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 6 }, children: [_jsx("span", { style: {
                                                        fontSize: 12,
                                                        fontWeight: 700,
                                                        color: colorTokens.textDark,
                                                        fontFamily: "'Nunito', sans-serif",
                                                    }, children: item.label }), !item.req && (_jsx("span", { style: {
                                                        fontSize: 9,
                                                        fontWeight: 700,
                                                        color: colorTokens.darkGrey,
                                                        padding: '1px 5px',
                                                        borderRadius: 3,
                                                        background: colorTokens.lightGrey,
                                                        fontFamily: "'Nunito', sans-serif",
                                                    }, children: t('landing.setup.optionalBadge') }))] }), _jsx("div", { style: {
                                                fontSize: 11,
                                                color: colorTokens.darkGrey,
                                                marginTop: 2,
                                                fontFamily: "'Nunito', sans-serif",
                                            }, children: item.desc })] })] }, i)))] }), _jsxs("button", { onClick: onStartSetup, style: btnPrimary, children: [t('landing.setup.startButton'), " ", _jsx(ArrowForwardIcon, { sx: { fontSize: 14 } })] })] }) }));
};
